import React from "react";
import PropTypes from "prop-types";
import { Query } from "react-apollo";

import ErrorBoundary from "components/Library/ErrorBoundary";
import UserHeader from "components/Library/UserHeader";
import AUTHOR_STREAM_HEADER_QUERY from "./AuthorStreamHeader.graphql";

// This function is a little bit of a compatibility component until we can get 
// the other places that use <UserHeader> to use Apollo as well.
export default function AuthorStreamHeader({ username }) {
  return (
    <ErrorBoundary>
      <Query query={AUTHOR_STREAM_HEADER_QUERY} variables={{ username }}>
        {({ loading, data }) => {
          return (
            <UserHeader person={loading ? {} : data.author} />
          );
        }}
      </Query>
    </ErrorBoundary>
  );
}

AuthorStreamHeader.propTypes = {
  username: PropTypes.string.isRequired,
};
